const getNextDate = (day: number) => {
  const today = new Date();
  const nextweek = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + day,
  );
  const reformatDate = formatDate(nextweek);
  return reformatDate;
};

export default getNextDate;

function formatDate(dateString: Date) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Adding 1 because months are zero-based
  const day = date.getDate();
  return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
}
